// ─────────────────────────────────────────────────────────────────
// MEMBERSHIP PLANS — single source of truth for Free / Pro Driver /
// Company. Both PricingPage and TrainingHub previously hardcoded their
// own separate (and slightly different) copies of this list.
//
// `colorKey` is semantic, not a literal hex — each page maps it
// through its own theme object.
// ─────────────────────────────────────────────────────────────────

export const PLANS = [
  {
    id: "free",
    label: "Free",
    icon: "🌐",
    price: "$0",
    period: "",
    colorKey: "muted",
    badge: null,
    desc: "Explore the platform before committing. No credit card required.",
    features: [
      "Browse all course listings",
      "View public load board",
      "Basic profile listing",
      "Access demo content",
      "Community access",
    ],
    locked: [
      "Verified badge",
      "State cheat sheets",
      "Apply to loads",
      "Company search visibility",
    ],
    cta: "Get Started Free",
    ctaStyle: "ghost",
  },
  {
    id: "driver",
    label: "Pro Driver",
    icon: "👤",
    price: "TBD",
    period: "/mo",
    colorKey: "teal",
    badge: "Most Popular",
    highlight: true,
    desc: "Everything a professional pilot car operator needs to get hired and grow.",
    features: [
      "Verified Driver Badge on profile",
      "Companies find & contact you directly",
      "Unlock all State Cheat Sheets",
      "State compliance PDFs after passing",
      "Discount on PPCA & NPCA courses",
      "Apply to unlimited loads",
      "Invoice builder + send to company",
      "Equipment marketplace listing",
      "Priority load board placement",
      "EBHL backhaul matching",
      "Direct permit office links",
    ],
    note: "Already certified? Upload your cert and get verified instantly. No course required.",
    cta: "Become a Member",
    ctaStyle: "primary",
  },
  {
    id: "company",
    label: "Company Plan",
    icon: "🏢",
    price: "TBD",
    period: "/mo",
    colorKey: "purple",
    badge: "For Carriers",
    desc: "Hire certified drivers. Post loads. Manage your fleet from one dashboard. Built for carriers, fleet managers, and dispatchers alike.",
    features: [
      "Post unlimited oversize loads",
      "Search certified driver database",
      "Verify driver cert status via API",
      "View full driver profiles + credentials",
      "Receive & approve driver invoices",
      "QuickBooks-ready invoice export",
      "Company verified badge",
      "ESG / EBHL carbon report",
      "Priority driver matching",
    ],
    cta: "Register Company",
    ctaStyle: "primary",
  },
];

export const PLANS_BY_ID = Object.fromEntries(PLANS.map((p) => [p.id, p]));
